export default __webpack_public_path__ + "static/media/nbabignew.9718f111.png";